module.exports = __webpack_public_path__ + "img/TAT-SING-consulting-group-black.c0350365.png";